import { ContactPageStep, useContact } from './hooks';
import {ContactConfirm} from './contactConfirm'
import { useEffect } from 'react';
import { ContactDetails } from './contactDetails';
import { ContactComplete } from './contactComplete';

export const Contact = () => {
  const {
    formik,
    contactPageStep,
    backPage,
    contactProps,
  } = useContact();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [contactPageStep]);

  switch (contactPageStep) {
    case ContactPageStep.Detail:
      return (
        <ContactDetails formik={formik} contactProps={contactProps}/>
      );
    case ContactPageStep.Confirm:
      return (
        <ContactConfirm formik={formik} backPage={backPage}/>
      );
    case ContactPageStep.Complete:
      return (  
        <ContactComplete/>
      );
  }
};
